import React, { useState } from 'react';
import { useClientStore } from 'apps/hooks';
import { observer } from 'mobx-react';

import { MenuItem, Avatar, OverflowTooltip } from 'components';
import { ArrowRight, ToggleIcon } from 'icons';
import { themes } from 'styles/themes/wikifactoryNew';
import { Workspace } from 'types';

const WorkspaceSwitcherMenuItems = observer(
  ({
    extraItems,
    excludeProfile,
  }: {
    excludeProfile?: boolean;
    extraItems?: React.ReactNode[];
  }) => {
    const clientStore = useClientStore();
    const { activeSpace, initiativeSpaces } = clientStore;
    const [hoverId, setHoverID] = useState('');

    const sortSpaces = (workspaces: Workspace[]) => {
      return workspaces.sort((a: Workspace, b: Workspace) => {
        if (a.id === activeSpace?.id) return -1;
        if (b.id === activeSpace?.id) return 1;
        return 0;
      });
    };

    const workspaces: Workspace[] = excludeProfile
      ? sortSpaces(initiativeSpaces)
      : sortSpaces(clientStore.workspaces);

    return (
      <>
        {workspaces.map(workspace => {
          const isSelected = activeSpace?.id === workspace.id;

          const handleClick = () => {
            clientStore.SetActiveWorkspace(workspace.id);
            clientStore.MaybeNavigateToTheDefaultSpaceRoute();
          };

          let text = workspace.content.title;
          let avatarName = workspace.content.slug;
          if (workspace.spaceType === 'INITIATIVE') {
            avatarName = text;
          }

          if (workspace.spaceType === 'PROFILE')
            text = `@${workspace.content.slug}`;

          return (
            <MenuItem
              key={workspace.id}
              onClick={handleClick}
              style={
                isSelected
                  ? {
                      borderBottom: `1px solid ${themes.color.wfGrey100}`,
                    }
                  : {}
              }
            >
              <div
                className='flex w-full justify-between items-center '
                onMouseEnter={() => {
                  setHoverID(workspace.id);
                }}
                onMouseLeave={() => {
                  setHoverID('');
                }}
              >
                <div className='flex items-center'>
                  <Avatar
                    src={workspace.content.avatar?.url}
                    name={avatarName}
                    selected={isSelected}
                  />
                  <p className='ml-2' data-testid={`space-${workspace.id}`}>
                    <OverflowTooltip className='w-48' text={text} />
                  </p>
                </div>
                {isSelected && hoverId === workspace.id ? (
                  <div className='mr-2 '>
                    <ToggleIcon />
                  </div>
                ) : (
                  hoverId === workspace.id && (
                    <div className='mr-2'>
                      <ArrowRight />
                    </div>
                  )
                )}
              </div>
            </MenuItem>
          );
        })}

        {extraItems}
      </>
    );
  },
);

export default WorkspaceSwitcherMenuItems;
